import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.8}
      d="m7 14.283 2.645 2.587a.477.477 0 0 0 .7-.051L18 7"
    />
  </svg>
);
export const CheckBigIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
